export default "__VITE_ASSET__cV4F6OGS__"